import InvoiceService from "@/apps/tatar/invoiceApp/InvoiceService";
import {
  Invoice,
  InvoiceAccount,
  InvoiceAccountBU,
  InvoiceAccountDataCategory,
  InvoiceDirection,
} from "@/apps/tatar/invoiceApp/RAInterfaces";
import {
  getDunningLabel,
  getInvoiceOposFilter,
} from "@/apps/tatar/invoiceApp/RAUtils";
import InvoiceView, {
  InvoiceViewLoader,
} from "@/apps/tatar/invoiceApp/components/InvoiceView";
import { RACBookingReason } from "@/apps/tatar/invoiceConfigApp/RACInterfaces";
import RACAccountBUForm from "@/apps/tatar/invoiceConfigApp/views/AccountingConfig/RACAccountBUForm";
import RACAccountForm from "@/apps/tatar/invoiceConfigApp/views/AccountingConfig/RACAccountForm";
import AssetLoader from "@/components/AssetLoader/AssetLoader";
import AssetQuery from "@/components/AssetLoader/AssetQuery";
import Userlabel from "@/components/AvatarComponent/Userlabel";
import DependingCalculationField from "@/components/Form/Fields/DependingCalculationField";
import FormFieldValues from "@/components/Form/Fields/FormFieldValues";
import FormStruct from "@/components/Form/FormStruct/FormStruct";
import { FV } from "@/components/Form/Validation/FormValidators";
import ModalManager from "@/components/ModalComponent/ModalManager";
import SearchList from "@/configurable/data/SearchList/SearchList";
import Log from "@/debug/Log";
import { ObjectId } from "@/model/db/General";
import BFFormSection from "@/modules/abstract-ui/data/form-section/BFFormSection";
import BFDropzone from "@/modules/abstract-ui/dropzone/BFDropzone";
import BFCheckbox from "@/modules/abstract-ui/forms/checkbox/BFCheckbox";
import BFAssetChooser from "@/modules/abstract-ui/forms/chooser/BFAssetChooser";
import BFChooserSelect from "@/modules/abstract-ui/forms/chooser/BFChooserSelect";
import BFDatefield from "@/modules/abstract-ui/forms/datefield/BFDatefield";
import BFInput from "@/modules/abstract-ui/forms/input/BFInput";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import BFDetailsButton from "@/modules/abstract-ui/general/Button/BFDetailsButton";
import BFDivider from "@/modules/abstract-ui/general/Divider/BFDivider";
import BFMessageBox from "@/modules/abstract-ui/general/Message/BFMessageBox";
import BFOverlay from "@/modules/abstract-ui/general/whisper/BFOverlay";
import BfIcon from "@/modules/abstract-ui/icon/BfIcon";
import { DefaultIcons } from "@/modules/abstract-ui/icon/DefaultIcons";
import InvoiceStruct from "@/redux/actions/struct/implemented/InvoiceStruct";
import CacheService from "@/services/CacheService";
import DataBusDefaults from "@/services/DataBusDefaults";
import PermissionService from "@/services/PermissionService";
import NumberUtils from "@/utils/ NumberUtils";
import DateUtils from "@/utils/DateUtils";
import { when } from "@/utils/Helpers";
import StringUtils from "@/utils/StringUtils";
import classNames from "classnames";
import { FormApi } from "final-form";
import { useState } from "react";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { Loader } from "rsuite";
import Collapse from "rsuite/esm/Animation/Collapse";
import i18n from "../../../../../../i18n";
import { AssetTypes } from "../../../../../../model/AssetTypes";
import MQ from "../../../../../../utils/MatchQueryUtils";
import CashBudgetBookingFooter from "../../../components/CashBudgetBookingFooter";
import CashBudgetDetailEntryCardContent from "../../../components/CashBudgetDetailEntryCardContent";
import { AssetCashBudgetEntry } from "../../../model/CashBudgetEntry";
import BookingService from "../../../services/BookingService";
import CBIdlyConnect from "./CBIdlyConnect";
import "./CBIdlyConnectInvoice.scss";
import CBIdlyConnectInvoiceSugggestion from "./CBIdlyConnectInvoiceSugggestion";
import CBIdlyConnectService, {
  InvoiceSuggestion,
} from "./CBIdlyConnectService";

interface CBIdlyConnectInvoiceProps {
  booking: AssetCashBudgetEntry;
  initialOpen?: boolean;
  suggestionOnly?: boolean;
}
const CBIdlyConnectInvoice = (props: CBIdlyConnectInvoiceProps) => {
  const openManualAction = () => {
    ModalManager.show({
      size: "xxl",
      noPadding: true,
      ignoreEscapeToClose: true,
      content: (state, setState, close) => (
        <CBIdlyConnectInvoiceManual
          booking={props.booking}
          close={close}
          onSubmit={() => {
            close();
          }}
        />
      ),
    });
  };

  const hasConnectedInvoices = Boolean(
    props.booking.data.opos?.invoicesBooked?.length
  );

  if (hasConnectedInvoices) {
    return (
      <div className={`cb-idly-connected-invoices`}>
         
        <BFFormSection
          className={classNames(`cb-idly-connect`)}
          initialOpen={props.suggestionOnly || props.initialOpen}
          title={i18n.t(
            "cb:CBIdlyConnect.Invoice.assignedInvoices",
            "Zugewiesene Rechnungen"
          )}
          disableCollapse
        >
          <div>
            <div className={`__flex __justify-end padding-bottom-10`}>
              <div className={`__flex __align-center`}>
                {props.booking.data.opos?.user && (
                  <Userlabel id={props.booking.data.opos.user} />
                )}
                {props.booking.data.opos?.date && (
                  <span className={`padding-left-10 __sub-text`}>
                    {StringUtils.formatDate(props.booking.data.opos.date)}
                  </span>
                )}
              </div>
              <div className={`fill`} />
              <BFButton
                appearance="outline"
                size="sm"
                onClick={async () => {
                  await CBIdlyConnectService.unlinkInvoice(props.booking._id);
                }}
              >
                {i18n.t(
                  "cb:CBIdlyConnect.Invoice.removeAssignment",
                  "Rechnungszuweisungen entfernen"
                )}
              </BFButton>
            </div>

            <div className={`assigned-invoices`}>
              <table className={`__full-width`}>
                <thead>
                  <tr>
                    <th className={`__text-align-left __h3 padding-right-20`}>
                      {i18n.t(
                        "cb:CBIdlyConnect.Invoice.assignedInvoice",
                        "Rechnung"
                      )}
                    </th>
                    <th className={` __h3 __text-align-right`}>
                      {i18n.t(
                        "cb:CBIdlyConnect.Invoice.assignedAmount",
                        "Zugewiesener Betrag"
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {props.booking.data.opos?.invoicesBooked.map(
                    (invoiceBooked) => (
                      <tr key={invoiceBooked.id}>
                        <td className={`padding-right-20`}>
                          <InvoiceViewLoader id={invoiceBooked.id} />
                        </td>
                        <td>
                          <div
                            className={`__font-size-md __weight-500 __text-align-right`}
                          >
                            {StringUtils.formatCurrency(invoiceBooked.value)}
                          </div>
                        </td>
                      </tr>
                    )
                  )}
                  {props.booking.data.opos?.manuallyBooked && (
                    <tr>
                      <td className={`padding-right-20`}>
                        {i18n.t(
                          "cb:CBIdlyConnect.Invoice.manualBooking",
                          "Manuelle Buchung"
                        )}
                      </td>
                      <td>
                        <div
                          className={`__font-size-md __weight-500 __text-align-right`}
                        >
                          {StringUtils.formatCurrency(
                            props.booking.data.opos.manuallyBooked.value
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </BFFormSection>
      </div>
    );
  }
  return (
    <>
      <CBIdlyConnect
        suggestionOnly={props.suggestionOnly}
        assetType={AssetTypes.Invoicing.Invoice}
        mapSuggestion={CBIdlyConnectService.mapSuggestionInvoice}
        matchQuery={MQ.and(
          MQ.eq("data.entity", props.booking.data.entity),
          MQ.nin("data.status", ["init", "declined"])
        )} // todo check for rent > 0 etc
        className="cb-idly-connect-invoice"
        title={i18n.t("cb:CBIdlyConnect.Invoice.header", "Rechnung zuweisen")}
        booking={props.booking}
        initialOpen={props.initialOpen}
        connectActionLabel={i18n.t(
          "cb:CBIdlyConnect.Invoice.assign",
          "Rechnung zuweisen"
        )}
        isConnected={(suggestion: InvoiceSuggestion) =>
          props.booking.data.opos?.invoicesBooked?.some(
            (e) => e.id === suggestion.asset._id
          )
        }
        disconnectActionLabel={i18n.t(
          "cb:CBIdlyConnect.Invoice.unassign",
          "Zuweisung aufheben"
        )}
        disconnectActionPromise={async (suggestion: InvoiceSuggestion) =>
          await CBIdlyConnectService.unlinkInvoice(props.booking._id)
        }
        connectActionPromise={async (suggestion: InvoiceSuggestion) => {
          const paymentsThatCouldMatch = suggestion.asset.data.payment.filter(
            (e) =>
              !e.payedDate &&
              NumberUtils.normalizeDecimal(e.amount) * -1 ===
                NumberUtils.normalizeDecimal(props.booking.data.value)
          );
          const installmentsThatCouldMatch =
            suggestion.asset.data.installment.filter(
              (e) =>
                !e.payedDate &&
                NumberUtils.normalizeDecimal(e.amount) * -1 ===
                  NumberUtils.normalizeDecimal(props.booking.data.value)
            );

          const fittingPayment = DateUtils.getNearestOfDates(
            props.booking.data.date,
            paymentsThatCouldMatch,
            (e) => new Date(e.date)
          );
          const fittingInstallment = DateUtils.getNearestOfDates(
            props.booking.data.date,
            installmentsThatCouldMatch,
            (e) => new Date(e.date)
          );

          await CBIdlyConnectService.linkInvoice(props.booking._id, [
            {
              invoiceId: suggestion.asset._id,
              value: props.booking.data.value * -1,
              finishedPayments: fittingPayment ? [fittingPayment.id] : [],
              finishedInstallments:
                !fittingPayment && fittingInstallment
                  ? [fittingInstallment.id]
                  : [],
            },
          ]);
        }}
        manualActionLabel={i18n.t(
          "cb:CBIdlyConnect.Invoice.manual",
          "Rechnung suchen"
        )}
        allowManualSearch
        renderSuggestion={(suggestion: InvoiceSuggestion) => (
          <CBIdlyConnectInvoiceSugggestion suggestion={suggestion} />
        )}
        renderSuggestionHint={CBIdlyConnectService.getSuggestionHintInvoice}
        // ruleActionData={(suggestion: InvoiceSuggestion) => ({
        //   assetDescription: `${suggestion.asset.id} ${suggestion.asset.data.invoice.invoiceId}`,
        //   assetName: i18n.t("cb:CBIdlyConnect.Invoice.AssetName", "Rechnung"),
        //   assetType: AssetTypes.Invoicing.Invoice,
        // })}
        suggestionPromise={async (booking: AssetCashBudgetEntry) =>
          await CBIdlyConnectService.fetchSuggestionsForInvoice(props.booking)
        }
        onManualAction={openManualAction}
      />
    </>
  );
};

export default CBIdlyConnectInvoice;

interface CBIdlyConnectInvoiceManualFormData {
  data: {
    invoiceId: ObjectId;
    value: number;
    outstandingOnBookingActive?: boolean;
    outstanding?: {
      manual: boolean;
      BU: ObjectId | null;
      BUCode: string;
      accountNumber: ObjectId | null;
      accountNumberCode: string;
      referenceField: string;
      date: Date;
      serviceDate: Date | null;
      usage: string;
      cost1: string;
      cost2: string;
      extraInfo: string[];
      reason: ObjectId;
    };

    finishedInstallments: string[];
    finishedPayments: string[];
  }[];
  outstandingOnBookingActive?: boolean;
  outstandingOnBooking?: {
    comment: string;
  };
}
export const CBIdlyConnectInvoiceManual = (props: {
  booking: AssetCashBudgetEntry;
  close: () => void;
  onSubmit: (data: CBIdlyConnectInvoiceManualFormData) => void;
}) => {
  const [uploading, setUploading] = useState(false);
  const [filter, setFilter] = useState<string | null>("open7Days");
  return (
    <BFDropzone
      onDrop={
        (acceptedFiles, rejectedFiles, event) => {
          Log.info(
            "###BFUpload drophandler",
            acceptedFiles,
            rejectedFiles,
            event
          );
          if (acceptedFiles && acceptedFiles.length > 0) {
            setUploading(true);
            BookingService.uploadBookingAttachments(
              props.booking,
              acceptedFiles
            )
              .then(() => {})
              .finally(() => {
                setUploading(false);
              });
          }
        }
        // this.onDropHandler(acceptedFiles, rejectedFiles, event)
      }
      render={(open) => (
        <FormStruct<CBIdlyConnectInvoiceManualFormData>
          initialValues={{ data: [] }}
          onSubmit={async (data) => {
            Log.info("###CBIdlyConnectInvoiceManual onSubmit", data);

            if (data.data.length === 0) {
              DataBusDefaults.toast({
                type: "error",
                text: i18n.t(
                  "cb:CBIdlyConnect.Invoice.manualEmpty",
                  "Sie müssen mindestens eine Rechnung auswählen, die Sie der Zahlung zuweisen möchten"
                ),
                duration: 6000,
              });
              return;
            }

            const result = await CBIdlyConnectService.linkInvoice(
              props.booking._id,
              await Promise.all(
                data.data.map(async (e) => {
                  const invoice = (await CacheService.load(
                    AssetTypes.Invoicing.Invoice,
                    e.invoiceId
                  )) as Invoice;
                  const reason =
                    e.outstanding?.reason &&
                    e.outstanding.reason !== "individual"
                      ? ((await CacheService.load(
                          AssetTypes.Invoicing.BookingReason,
                          e.outstanding.reason
                        )) as RACBookingReason)
                      : null;
                  const account = e.outstanding?.accountNumber
                    ? ((await CacheService.load(
                        AssetTypes.Invoicing.Account,
                        e.outstanding.accountNumber
                      )) as InvoiceAccount)
                    : null;
                  const accountBU = e.outstanding?.BU
                    ? ((await CacheService.load(
                        AssetTypes.Invoicing.AccountBU,
                        e.outstanding.BU
                      )) as InvoiceAccountBU)
                    : null;

                  const bookingData = e.outstandingOnBookingActive
                    ? e.outstanding?.reason !== "individual"
                      ? {
                          ...CBIdlyConnectService.getBookingData(invoice),
                          BUCode: undefined,
                          accountNumbeCode: undefined,
                        }
                      : {
                          BU: e.outstanding.BU,
                          // BUCode: e.outstanding.BUCode,
                          accountNumber: e.outstanding.accountNumber,
                          // accountNumberCode: e.outstanding.accountNumberCode,
                          referenceField: e.outstanding.referenceField,
                          date: e.outstanding.date,
                          serviceDate: e.outstanding.serviceDate,
                          usage: e.outstanding.usage,
                          cost1: e.outstanding.cost1,
                          cost2: e.outstanding.cost2,
                          extraInfo: e.outstanding.extraInfo,
                        }
                    : null;

                  return {
                    invoiceId: e.invoiceId,
                    value: e.value,

                    finishedPayments: e.finishedPayments || [],
                    finishedInstallments: e.finishedInstallments || [],
                    outstanding: e.outstandingOnBookingActive
                      ? {
                          booking: {
                            ...bookingData,
                            value: invoice.data.opos?.openSum7Days - e.value,
                            accountNumber: account._id,
                            BU: accountBU?._id || null,
                            accountNumberCode: undefined,
                            BUCode: undefined,
                          } as any,
                          comment: "",
                          name:
                            e.outstanding.reason !== "individual"
                              ? i18n.t(
                                  "cb:CBIdlyConnect.Invoice.individual",
                                  "Individuell"
                                )
                              : reason?.data.name,
                          value: e.value,
                        }
                      : null,
                  };
                })
              ),
              data.outstandingOnBookingActive
                ? {
                    comment: data.outstandingOnBooking?.comment || "",
                    value:
                      (props.booking.data.value -
                        (data.data
                          .map((e) => e.value * -1)
                          .reduce((a, b) => a + b, 0) || 0)) *
                      -1,
                  }
                : undefined
            );
            props.onSubmit(result);
          }}
          title={i18n.t(
            "cb:CBIdlyConnect.Invoice.manualTitle",
            "Rechnung zuweisen"
          )}
          submitText={i18n.t(
            "cb:CBIdlyConnect.Invoice.manualSubmit",
            "Rechnung zuweisen"
          )}
          className={"cb-idly-connect-invoice-manual"}
          onAbort={props.close}
          render={(formProps) => (
            <Field name={"data"}>
              {({ input, meta }) => {
                const renderSearch = (firstAsset?: Invoice) => (
                  <SearchList
                    key="search-list"
                    assetType={AssetTypes.Invoicing.Invoice}
                    matchQuery={MQ.and(
                      MQ.eq("data.entity", props.booking.data.entity),
                      when(firstAsset, () =>
                        MQ.eq(
                          "data.invoice.contact",
                          firstAsset.data.invoice.contact
                        )
                      ),
                      when(input.value.length > 0, () =>
                        MQ.nin(
                          "_id",
                          input.value.map((e) => e.invoiceId)
                        )
                      ),
                      getInvoiceOposFilter().find((e) => e.value === filter).mq
                    )}
                    helpers={[
                      {
                        label:
                          props.booking.data.value > 0
                            ? i18n.t(
                                "cb:idlySearchFurther.PaymentSender",
                                "Bezahlt von"
                              )
                            : i18n.t(
                                "cb:idlySearchFurther.Recipient",
                                "Bezahlt an"
                              ),
                        value: props.booking.data.recipient,
                      },
                      {
                        label: i18n.t(
                          "cb:idlySearchFurther.Usage",
                          "Verwendungszweck"
                        ),
                        value: props.booking.data.usage,
                      },
                    ]}
                    renderAsset={(node: Invoice) => (
                      <div className={`invoice-entry`}>
                        <InvoiceView
                          invoice={node}
                          compareBooking={props.booking}
                        />
                        <div className={`__flex __justify-end`}>
                          <BFDetailsButton
                            noPadding
                            data={{
                              assetType: AssetTypes.Invoicing.Invoice,
                              assetId: node._id,
                            }}
                            appearance="link"
                            size="xs"
                          >
                            <BfIcon {...DefaultIcons.EDIT} size="xs" />
                          </BFDetailsButton>
                          <BFDivider vertical />
                          <BFButton
                            size="xs"
                            appearance="outline"
                            onClick={() => {
                              input.onChange([
                                ...input.value,
                                {
                                  invoiceId: node._id,
                                  value: 0, //props.booking.data.value * -1,
                                },
                              ]);
                            }}
                          >
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.add",
                              "Hinzufügen"
                            )}
                          </BFButton>
                        </div>
                      </div>
                    )}
                  />
                );
                return (
                  <div className={`cb-idly-connect-invoice-manual-content`}>
                    <div className={`left-content`}>
                      <div
                        className={`__flex padding-top-10 padding-right-10 __align-center`}
                      >
                        <div className={`__h3 padding-left-10 __flex-1`}>
                          {i18n.t(
                            "cb:CBIdlyConnect.Invoice.searchFurther",
                            "Rechnung suchen"
                          )}
                        </div>
                        <BFChooserSelect
                          value={filter}
                          data={getInvoiceOposFilter()}
                          onChange={(value: string) => setFilter(value)}
                        />
                      </div>
                      <div className={`booking-search`}>
                        {input.value.length ? (
                          <AssetLoader
                            assetType={AssetTypes.Invoicing.Invoice}
                            id={input.value[0].invoiceId}
                            renderLoading={() => (
                              <div className={`__flex __justify-center`}>
                                <Loader size="xs" />
                              </div>
                            )}
                            render={(firstAsset: Invoice) => (
                              <>{renderSearch(firstAsset)}</>
                            )}
                          />
                        ) : (
                          renderSearch()
                        )}
                      </div>
                    </div>
                    <div className={`right-content`}>
                      <div className={`right-header`}>
                        <div className={`booking-preview__container`}>
                          <div className={`__h3 padding-bottom-10`}>
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.booking",
                              "Zugehörige Buchung"
                            )}
                          </div>
                          <div className={`booking-preview __card`}>
                            <CashBudgetDetailEntryCardContent
                              entry={props.booking}
                              // showAccountData
                              showCategory
                              simple
                            />

                            <CashBudgetBookingFooter
                              booking={props.booking}
                              onUpload={open}
                              uploading={uploading}
                            />
                          </div>
                        </div>
                        <div className={`booking-data__container`}>
                          <div className={`__h3 padding-bottom-10`}>
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.bookingData",
                              "Buchungsdaten"
                            )}
                          </div>
                          <table className={`booking-data`}>
                            <tbody>
                              <tr>
                                <td className={`booking-data__label`}>
                                  {i18n.t(
                                    "cb:CBIdlyConnect.Invoice.valueToBook",
                                    "Zu buchender Betrag"
                                  )}
                                </td>
                                <td className={`booking-data__value`}>
                                  {StringUtils.formatCurrency(
                                    props.booking.data.value * -1
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className={`booking-data__label`}>
                                  {i18n.t(
                                    "cb:CBIdlyConnect.Invoice.valueBooked",
                                    "Gebuchter Betrag"
                                  )}
                                </td>
                                <td className={`booking-data__value`}>
                                  {StringUtils.formatCurrency(
                                    input.value
                                      .map((e) => e.value)
                                      .reduce((a, b) => a + b, 0) || 0
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className={`booking-data__label __bold`}>
                                  {i18n.t(
                                    "cb:CBIdlyConnect.Invoice.openToBook",
                                    "Offener Betrag"
                                  )}
                                </td>
                                <td className={`booking-data__value  __bold`}>
                                  {StringUtils.formatCurrency(
                                    props.booking.data.value * -1 -
                                      input.value
                                        .map((e) => e.value)
                                        .reduce((a, b) => a + b, 0) || 0
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className={`list-of-invoices`}>
                        <table>
                          <thead>
                            <tr style={{ width: "auto" }}>
                              <th className={`__text-align-left`}>
                                {i18n.t(
                                  "cb:CBIdlyConnect.Invoice.invoices",
                                  "Rechnungen"
                                )}
                              </th>
                              <th
                                style={{ width: 400 }}
                                className={`__text-align-left`}
                              >
                                {i18n.t(
                                  "cb:CBIdlyConnect.Invoice.booking",
                                  "Verbuchung"
                                )}
                              </th>
                              <th style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {input.value.length === 0 && (
                              <tr>
                                <td colSpan={3}>
                                  <div className={`no-invoices __sub-text`}>
                                    {i18n.t(
                                      "cb:CBIdlyConnect.Invoice.noInvoicesYet",
                                      "Noch keine Rechnungen zugewiesen. Suchen Sie die passende Rechnung aus und buchen Sie den entsprechenden Betrag."
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )}
                            {input.value.map((entry, index) => (
                              <>
                                <tr
                                  className={`invoice-entry`}
                                  key={entry.invoiceId}
                                >
                                  <AssetLoader
                                    assetType={AssetTypes.Invoicing.Invoice}
                                    id={entry.invoiceId}
                                    renderLoading={() => (
                                      <td colSpan={3}>
                                        <div
                                          className={`__flex __justify-center`}
                                        >
                                          <Loader size="xs" />
                                        </div>
                                      </td>
                                    )}
                                    render={(invoice: Invoice) => {
                                      const cdnOriginal =
                                        invoice.data.invoice.file;
                                      const cdnDataOriginal = {
                                        filename:
                                          InvoiceService.generateFilenameForInvoice(
                                            invoice
                                          ),
                                        assetField: "data.invoice.file",
                                        assetId: invoice._id,
                                        assetType: "invoice",
                                        cdnData: cdnOriginal,
                                        cdnId: cdnOriginal.id,
                                      };
                                      return (
                                        <>
                                          <td className={`invoice-view-column`}>
                                            <InvoiceView
                                              invoice={invoice}
                                              compareBooking={props.booking}
                                            />
                                            {invoice.data.reminder?.reminderData
                                              ?.filter(
                                                (e) =>
                                                  !input.value.some(
                                                    (a) =>
                                                      a.invoiceId ===
                                                      e.reminderId
                                                  )
                                              )
                                              .map((reminder) => (
                                                <div
                                                  className={`padding-bottom-6`}
                                                >
                                                  <BFMessageBox
                                                    small
                                                    inline
                                                    style={{
                                                      marginLeft: 82,
                                                    }}
                                                    type="info"
                                                    key={reminder.reminderId}
                                                  >
                                                    <div
                                                      className={`__flex __align-center`}
                                                    >
                                                      <div>
                                                        {getDunningLabel(
                                                          reminder.reminderLevel
                                                        )}
                                                      </div>
                                                      <div>
                                                        {StringUtils.formatCurrency(
                                                          reminder.value,
                                                          null,
                                                          null,
                                                          invoice.data.invoice
                                                            .value.currency
                                                        )}
                                                      </div>

                                                      <BFButton
                                                        noPadding
                                                        size="xs"
                                                        appearance="link"
                                                        onClick={() => {
                                                          input.onChange([
                                                            ...input.value,
                                                            {
                                                              invoiceId:
                                                                reminder.reminderId,
                                                              value:
                                                                reminder.value,
                                                            },
                                                          ]);
                                                        }}
                                                      >
                                                        {i18n.t(
                                                          "cb:CBIdlyConnect.Invoice.addReminderToList",
                                                          "Mahnung hinzufügen"
                                                        )}
                                                      </BFButton>
                                                    </div>
                                                  </BFMessageBox>
                                                </div>
                                              ))}
                                          </td>
                                          <td className={`booking-column`}>
                                            <Field
                                              name={`data[${index}].value`}
                                              validate={FV.compose(
                                                FV.required(),
                                                FV.not(0)
                                              )}
                                            >
                                              {({ input, meta }) => {
                                                const opemAmountRest =
                                                  invoice.data.opos
                                                    ?.openSum7Days -
                                                  input.value;
                                                return (
                                                  <>
                                                    <BFOverlay
                                                      trigger="focus"
                                                      enterable
                                                      speakerFC={(close) => (
                                                        <PaymentOverlay
                                                          invoice={invoice}
                                                          index={index}
                                                          value={input.value}
                                                          onChange={(value) => {
                                                            input.onChange(
                                                              value
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                      placement="bottom"
                                                    >
                                                      <BFInput
                                                        {...input}
                                                        {...FV.getValidation(
                                                          meta
                                                        )}
                                                        textAlign="right"
                                                        prefix={i18n.t(
                                                          "cb:CBIdlyConnect.InvoiceAmount",
                                                          "Betrag"
                                                        )}
                                                        placeholder={i18n.t(
                                                          "cb:CBIdlyConnect.Invoice.value",
                                                          "Betrag"
                                                        )}
                                                        type="priceInput"
                                                        suffix={StringUtils.getCurrencySymbol()}
                                                      />
                                                    </BFOverlay>

                                                    <div
                                                      className={`__sub-text padding-top-6 __text-align-right`}
                                                    >
                                                      {i18n.t(
                                                        "cb:CBIdlyConnect.Invoice.openAmountRest",
                                                        "Restliche offener Betrag: {{amount}}",
                                                        {
                                                          amount:
                                                            StringUtils.formatCurrency(
                                                              opemAmountRest
                                                            ),
                                                        }
                                                      )}
                                                    </div>
                                                    <Collapse
                                                      unmountOnExit
                                                      in={opemAmountRest !== 0}
                                                    >
                                                      <div>
                                                        <div
                                                          className={`__flex __flex-column __justify-end padding-top-6 __text-align-right`}
                                                        >
                                                          <Field
                                                            name={`data[${index}].outstandingOnBookingActive`}
                                                          >
                                                            {({ input }) => (
                                                              <>
                                                                <div>
                                                                  <BFCheckbox
                                                                    checked={
                                                                      input.value
                                                                    }
                                                                    onChange={(
                                                                      _,
                                                                      checked
                                                                    ) => {
                                                                      input.onChange(
                                                                        checked
                                                                      );

                                                                      if (
                                                                        checked
                                                                      ) {
                                                                        formProps.form.change(
                                                                          `data[${index}].outstanding`,
                                                                          {
                                                                            manual:
                                                                              false,
                                                                            ...CBIdlyConnectService.getBookingData(
                                                                              invoice
                                                                            ),
                                                                          }
                                                                        );
                                                                      } else {
                                                                        formProps.form.change(
                                                                          `data[${index}].outstanding`,
                                                                          null
                                                                        );
                                                                      }
                                                                    }}
                                                                  >
                                                                    {i18n.t(
                                                                      "cb:CBIdlyConnect.Invoice.outstandingOnInvoice",
                                                                      "Restbetrag der Rechnung verbuchen"
                                                                    )}
                                                                  </BFCheckbox>
                                                                </div>
                                                              </>
                                                            )}
                                                          </Field>
                                                        </div>
                                                      </div>
                                                    </Collapse>
                                                  </>
                                                );
                                              }}
                                            </Field>
                                          </td>
                                          <td className={`action-column`}>
                                            <BFButton
                                              size={"sm"}
                                              appearance="outline"
                                              className={`remove-invoice`}
                                              onClick={() => {
                                                input.onChange(
                                                  input.value.filter(
                                                    (e) =>
                                                      e.invoiceId !==
                                                      entry.invoiceId
                                                  )
                                                );
                                              }}
                                            >
                                              {i18n.t(
                                                "cb:CBIdlyConnect.Invoice.remove",
                                                "Entfernen"
                                              )}
                                            </BFButton>
                                          </td>
                                        </>
                                      );
                                    }}
                                  />
                                </tr>
                                <tr className={`invoice-outstanding`}>
                                  <td colSpan={3}>
                                    <AssetLoader
                                      assetType={AssetTypes.Invoicing.Invoice}
                                      id={entry.invoiceId}
                                      renderError={() => null}
                                      render={(invoice: Invoice) => (
                                        <FormFieldValues
                                          names={[
                                            `data[${index}].outstandingOnBookingActive`,
                                            `data[${index}].value`,
                                          ]}
                                        >
                                          {([
                                            outstandingOnBookingActive,
                                            value,
                                          ]) => (
                                            <Collapse
                                              unmountOnExit
                                              in={
                                                outstandingOnBookingActive &&
                                                invoice.data.opos
                                                  ?.openSum7Days -
                                                  value !==
                                                  0
                                              }
                                            >
                                              <div>
                                                <SubOutstandingForm
                                                  formProps={formProps.form}
                                                  invoice={invoice}
                                                  index={index}
                                                  direction={
                                                    invoice.data.direction
                                                  }
                                                  entity={invoice.data.entity}
                                                  reasonType={
                                                    invoice.data.opos
                                                      ?.openSum7Days -
                                                      value >
                                                    0
                                                      ? "overbook"
                                                      : "underbook"
                                                  }
                                                />
                                              </div>
                                            </Collapse>
                                          )}
                                        </FormFieldValues>
                                      )}
                                    />
                                  </td>
                                </tr>
                              </>
                            ))}
                            {input.value.length > 0 && (
                              <tr className={`result-row`}>
                                <td></td>
                                <td>
                                  <ResultRow
                                    booking={props.booking}
                                    bookedValues={
                                      input.value?.map((e) => e.value) || []
                                    }
                                  />
                                </td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                );
              }}
            </Field>
          )}
        />
      )}
    />
  );
};

const ResultRow = (props: {
  booking: AssetCashBudgetEntry;
  bookedValues: number[];
}) => {
  const bookedSum = props.bookedValues.reduce((a, b) => a + (b || 0), 0);
  const openAmount = props.booking.data.value * -1 - bookedSum || 0;

  return (
    <div className={`invoice-booking-result`}>
      <div className={`open-amount-label`}>
        {StringUtils.formatCurrency(openAmount)} (
        {i18n.t("cb:CBIdlyConnect.Invoice.openAmount", "Offener Betrag")})
      </div>

      <Collapse unmountOnExit in={openAmount !== 0}>
        <div>
          <div className={`__flex __flex-column __justify-end padding-top-10`}>
            <Field name={`outstandingOnBookingActive`}>
              {({ input }) => (
                <>
                  <div>
                    <BFCheckbox
                      checked={input.value}
                      onChange={(_, checked) => {
                        input.onChange(checked);
                      }}
                    >
                      {i18n.t(
                        "cb:CBIdlyConnect.Invoice.outstandingOnBooking",
                        "Restbetrag auf Buchung verbuchen"
                      )}
                    </BFCheckbox>
                  </div>
                  <Collapse unmountOnExit in={input.value}>
                    <div>
                      <div className={`__text-align-left`}>
                        <Field name="outstandingOnBooking.comment">
                          {({ input, meta }) => (
                            <BFInput
                              {...input}
                              {...FV.getValidation(meta)}
                              textAlign="left"
                              label={i18n.t(
                                "cb:CBIdlyConnect.Invoice.outstandingOnBookingCommentLabel",
                                "Kommentar"
                              )}
                              placeholder={i18n.t(
                                "cb:CBIdlyConnect.Invoice.outstandingOnBookingComment",
                                "Wieso wird der Restbetrag auf der Buchung verbucht?"
                              )}
                              type="text"
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  </Collapse>
                </>
              )}
            </Field>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

const SubOutstandingForm = (props: {
  index: number;
  reasonType: "overbook" | "underbook";
  entity: ObjectId;
  direction: InvoiceDirection;
  invoice: Invoice;
  formProps: FormApi<any>;
}) => {
  const disableEditAccounting =
    Boolean(
      PermissionService.hasBusinessUnitRole("invConf_accounting", false, false)
    ) === false;
  return (
    <FormFieldValues
      names={[
        `data[${props.index}].outstandingOnBookingActive`,
        `data[${props.index}].value`,
      ]}
    >
      {([outstandingOnBookingActive, value]) => (
        <div>
          <div className={`__h3 padding-bottom-10 padding-top-10`}>
            {i18n.t(
              "cb:CBIdlyConnect.Invoice.outstandingOnInvoiceSubTitle",
              "Restbetragsverbuchung"
            )}
          </div>
          <div className={`__flex`}>
            <div className={`__field`}>
              <Field
                name={`data[${props.index}].outstanding.reason`}
                validate={FV.required()}
                defaultValue={"individual"}
              >
                {({ input, meta }) => (
                  <AssetQuery
                    assetType={AssetTypes.Invoicing.BookingReason}
                    query={MQ.and(
                      MQ.eq("data.reasonType", props.reasonType),
                      MQ.eq("data.entityId", props.entity),
                      MQ.eq("data.direction", props.direction)
                    )}
                    render={(data: RACBookingReason[]) => (
                      <BFChooserSelect
                        // overlayHeight={300}
                        // assetType={AssetTypes.Invoicing.BookingReason}
                        // matchQuery={MQ.and(
                        //   MQ.eq("data.reasonType", props.reasonType),
                        //   MQ.eq("data.entityId", props.entity),
                        //   MQ.eq("data.direction", props.direction)
                        // )}
                        data={[
                          {
                            label: i18n.t(
                              "cb:CBIdlyConnect.Invoice.individual",
                              "Individuell"
                            ),
                            value: "individual",
                          },
                          ...data.map((asset) => ({
                            value: asset._id,
                            label: asset.data.name,
                            description: asset.data.description,
                          })),
                        ]}
                        value={input.value}
                        onChange={(value) => {
                          input.onChange(value);
                          if (value !== "individual") {
                            const reason = data.find((e) => e._id === value);

                            if (reason) {
                              new Promise(async () => {
                                const account = await CacheService.getData({
                                  assetType: AssetTypes.Invoicing.Account,
                                  id: reason.data.accountId,
                                  oType: "asset",
                                });
                                if (account) {
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.accountNumberCode`,
                                    account.data.accountNumber
                                  );
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.accountNumber`,
                                    account._id
                                  );
                                } else {
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.accountNumberCode`,
                                    ""
                                  );
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.accountNumber`,
                                    ""
                                  );
                                }

                                if (reason.data.accountBUId) {
                                  const accountBU = await CacheService.getData({
                                    assetType: AssetTypes.Invoicing.AccountBU,
                                    id: reason.data.accountBUId,
                                    oType: "asset",
                                  });
                                  if (accountBU) {
                                    props.formProps.mutators.setValue(
                                      `data[${props.index}].outstanding.BU`,
                                      accountBU._id
                                    );
                                    props.formProps.mutators.setValue(
                                      `data[${props.index}].outstanding.BUCode`,
                                      accountBU.data.accountNumber
                                    );
                                  }
                                } else {
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.BU`,
                                    ""
                                  );
                                  props.formProps.mutators.setValue(
                                    `data[${props.index}].outstanding.BUCode`,
                                    ""
                                  );
                                }
                              }).finally(() => {});
                            }
                          }
                        }}
                        label={
                          i18n.t(
                            "cb:CBIdlyConnect.Invoice.outstandingReason",
                            "Grund der Restbetragsverbuchung"
                          ) + "*"
                        }
                      />
                    )}
                  />
                )}
              </Field>
            </div>
            <FormFieldValues
              names={[`data[${props.index}].outstanding.reason`]}
            >
              {([reason]) => (
                <>
                  {reason !== "individual" && (
                    <div className={`__field padding-top-20`}>
                      <Field name={`data[${props.index}].outstanding.manual`}>
                        {({ input, meta }) => (
                          <BFCheckbox
                            checked={input.value}
                            onChange={(_, checked) => {
                              input.onChange(checked);
                            }}
                          >
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.manualBooking",
                              "Buchung manuell anpassen"
                            )}
                          </BFCheckbox>
                        )}
                      </Field>
                    </div>
                  )}
                </>
              )}
            </FormFieldValues>
          </div>
          <FormFieldValues
            names={[
              `data[${props.index}].outstanding.manual`,
              `data[${props.index}].outstanding.reason`,
            ]}
          >
            {([manual, reason]) => (
              <Collapse in={manual || reason === "individual"} unmountOnExit>
                <div>
                  <div className={`booking-outstanding-form-fields __flex`}>
                    <div className={`__flex-1`}>
                      <BFInput
                        className={`first-row`}
                        noBorderRadiusBottom
                        readonly
                        prefix={
                          <div className={`__flex`}>
                            <div className={`__flex-1`}>
                              {i18n.t("ra:RABookInvoiceForm.amount", "Betrag")}
                            </div>
                          </div>
                        }
                        type="priceInput"
                        textAlign="right"
                        suffix={StringUtils.getCurrencySymbol(
                          props.invoice.data.invoice.value.converted?.currency
                        )}
                        value={props.invoice.data.opos?.openSum7Days - value}
                      />

                      <Field
                        name={`data[${props.index}].outstanding.accountNumberCode`}
                        validate={FV.compose(FV.required())}
                      >
                        {({ input, meta }) => (
                          <>
                            <BFInput
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.accountNumber",
                                "Buchungskonto"
                              )}
                              removeSuffixPadding
                              suffix={
                                <BFOverlay
                                  trigger="click"
                                  enterable
                                  placement="bottomEnd"
                                  speakerFC={(close) => (
                                    <div>
                                      <BFAssetChooser
                                        height={500}
                                        // value={input.value}
                                        focusOnMount
                                        assetType={AssetTypes.Invoicing.Account}
                                        matchQuery={MQ.and(
                                          MQ.eq("data.entity", props.entity)
                                        )}
                                        groups={[
                                          {
                                            matchQuery: MQ.eq(
                                              "data.category",
                                              InvoiceAccountDataCategory.GENERAL_LEDGER
                                            ),
                                            label: i18n.t(
                                              "ra:RABookInvoiceForm.generalLedger",
                                              "Sachkonto"
                                            ),
                                            value:
                                              InvoiceAccountDataCategory.GENERAL_LEDGER,
                                          },
                                          {
                                            matchQuery: MQ.eq(
                                              "data.category",
                                              InvoiceAccountDataCategory.DEBTOR
                                            ),
                                            label: i18n.t(
                                              "ra:RABookInvoiceForm.debitor",
                                              "Debitoren"
                                            ),
                                            value:
                                              InvoiceAccountDataCategory.DEBTOR,
                                          },
                                          {
                                            matchQuery: MQ.eq(
                                              "data.category",
                                              InvoiceAccountDataCategory.CREDITOR
                                            ),
                                            label: i18n.t(
                                              "ra:RABookInvoiceForm.creditor",
                                              "Kreditoren"
                                            ),
                                            value:
                                              InvoiceAccountDataCategory.CREDITOR,
                                          },
                                          {
                                            matchQuery: MQ.eq(
                                              "data.category",
                                              InvoiceAccountDataCategory.NONE
                                            ),
                                            label: i18n.t(
                                              "ra:RABookInvoiceForm.none",
                                              "Sonstiges"
                                            ),
                                            value:
                                              InvoiceAccountDataCategory.NONE,
                                          },
                                        ]}
                                        getOption={(node: InvoiceAccount) => ({
                                          label: node.data.description,
                                          value: node._id,
                                          subLabel: node.data.accountNumber,
                                        })}
                                        onChange={(
                                          value,
                                          asset: InvoiceAccount
                                        ) => {
                                          input.onChange(
                                            asset.data.accountNumber
                                          );
                                          close();
                                        }}
                                      />
                                    </div>
                                  )}
                                >
                                  <BFButton
                                    appearance="link"
                                    size="xxs"
                                    onClick={() => {}}
                                  >
                                    <BfIcon
                                      {...DefaultIcons.SEARCH}
                                      size="xxs"
                                    />
                                  </BFButton>
                                </BFOverlay>
                              }
                              {...input}
                            />
                          </>
                        )}
                      </Field>

                      <div className={`additional-info-row`}>
                        <div className={`left`} />
                        <div className={`additiona-info-value`}>
                          <DependingCalculationField
                            validate={FV.compose(FV.required())}
                            throttle={500}
                            dependingField={`data[${props.index}].outstanding.accountNumberCode`}
                            name={`data[${props.index}].outstanding.accountNumber`}
                            calulationPromise={async (value) => {
                              const invoiceAccount =
                                (await CacheService.getData({
                                  assetType: AssetTypes.Invoicing.Account,
                                  query: MQ.and(
                                    MQ.eq("data.accountNumber", value),
                                    MQ.eq("data.entity", props.entity)
                                  ),
                                  forceReload: true,
                                  oType: "asset",
                                })) as InvoiceAccount;

                              if (invoiceAccount) {
                                if (invoiceAccount.data.defaultBU) {
                                  const invoiceBU = await CacheService.getData({
                                    assetType: AssetTypes.Invoicing.AccountBU,
                                    id: invoiceAccount.data.defaultBU,
                                    oType: "asset",
                                  });
                                  if (invoiceBU) {
                                    props.formProps.change(
                                      `data[${props.index}].outstanding.BUCode`,
                                      invoiceBU.data.accountNumber
                                    );
                                  }
                                }
                                return {
                                  value: invoiceAccount._id,
                                  data: invoiceAccount,
                                };
                              } else {
                                throw new Error(
                                  i18n.t(
                                    "ra:RABookInvoiceForm.AccountNumberError",
                                    "Buchungskonto nicht gefunden"
                                  )
                                );
                              }
                            }}
                            renderLoading={() => <Loader size="xs" />}
                            renderError={(error, value: string, reload) => (
                              <div className={`__error`}>
                                {error?.message || "error"}

                                <BFButton
                                  disabled={disableEditAccounting}
                                  tooltip={
                                    disableEditAccounting
                                      ? {
                                          tooltip: i18n.t(
                                            "ra:RABookInvoiceForm.disabledNoPermissionAccouns",
                                            "Sie haben keine Berechtigung, um Buchungskonten zu erstellen"
                                          ),
                                        }
                                      : undefined
                                  }
                                  appearance="link"
                                  noPadding
                                  size="xs"
                                  onClick={() => {
                                    ModalManager.show({
                                      noPadding: true,
                                      size: "sm",
                                      content: (state, setState, close) => (
                                        <RACAccountForm
                                          direction={
                                            props.invoice.data.direction
                                          }
                                          entityId={props.entity}
                                          onClose={close}
                                          onSubmit={(node: InvoiceAccount) => {
                                            props.formProps.change(
                                              `data[${props.index}].outstanding.accountNumberCode`,
                                              node.data.accountNumber
                                            );
                                            props.formProps.change(
                                              `data[${props.index}].outstanding.accountNumber`,
                                              node._id
                                            );
                                            close();
                                            reload();
                                          }}
                                          initialValues={{
                                            accountNumber: value,
                                          }}
                                        />
                                      ),
                                    });
                                  }}
                                >
                                  {i18n.t(
                                    "Global.Buttons.establish",
                                    "Anlegen"
                                  )}
                                </BFButton>
                              </div>
                            )}
                            renderValue={(
                              value: any,
                              data: InvoiceAccount,
                              reload
                            ) => (
                              <div className={`__flex full-width`}>
                                <div className={`__flex-1`}>
                                  {data.data.description}
                                </div>

                                <BFButton
                                  disabled={disableEditAccounting}
                                  tooltip={
                                    disableEditAccounting
                                      ? {
                                          tooltip: i18n.t(
                                            "ra:RABookInvoiceForm.disabledNoPermissionAccouns",
                                            "Sie haben keine Berechtigung, um Buchungskonten zu erstellen"
                                          ),
                                        }
                                      : undefined
                                  }
                                  appearance="link"
                                  noPadding
                                  className={`padding-5`}
                                  size="xs"
                                  onClick={() => {
                                    ModalManager.show({
                                      noPadding: true,
                                      size: "sm",
                                      content: (state, setState, close) => (
                                        <RACAccountForm
                                          account={data}
                                          direction={
                                            props.invoice.data.direction
                                          }
                                          entityId={props.entity}
                                          onClose={close}
                                          onSubmit={(node: InvoiceAccount) => {
                                            close();
                                            reload();
                                          }}
                                          initialValues={{
                                            accountNumber: value,
                                          }}
                                        />
                                      ),
                                    });
                                  }}
                                >
                                  <BfIcon {...DefaultIcons.EDIT} size={"xxs"} />
                                </BFButton>
                              </div>
                            )}
                          />
                        </div>
                      </div>

                      <Field name={`data[${props.index}].outstanding.BUCode`}>
                        {({ input, meta }) => (
                          <>
                            <BFInput
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.BU",
                                "Buchungsschlüssel"
                              )}
                              removeSuffixPadding
                              suffix={
                                <BFOverlay
                                  trigger="click"
                                  enterable
                                  placement="bottomEnd"
                                  speakerFC={(close) => (
                                    <div>
                                      <BFAssetChooser
                                        height={500}
                                        // value={input.value}
                                        matchQuery={MQ.and(
                                          MQ.eq("data.entity", props.entity)
                                        )}
                                        focusOnMount
                                        assetType={
                                          AssetTypes.Invoicing.AccountBU
                                        }
                                        getOption={(
                                          node: InvoiceAccountBU
                                        ) => ({
                                          label: node.data.description,
                                          value: node._id,
                                          subLabel: node.data.accountNumber,
                                        })}
                                        onChange={(
                                          value,
                                          asset: InvoiceAccountBU
                                        ) => {
                                          input.onChange(
                                            asset.data.accountNumber
                                          );
                                          close();
                                        }}
                                      />
                                    </div>
                                  )}
                                >
                                  <BFButton
                                    appearance="link"
                                    size="xxs"
                                    onClick={() => {}}
                                  >
                                    <BfIcon
                                      {...DefaultIcons.SEARCH}
                                      size="xxs"
                                    />
                                  </BFButton>
                                </BFOverlay>
                              }
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>

                      <div className={`additional-info-row`}>
                        <div className={`left`} />
                        <div className={`additiona-info-value`}>
                          <DependingCalculationField
                            throttle={500}
                            dependingField={`data[${props.index}].outstanding.BUCode`}
                            name={`data[${props.index}].outstanding.BU`}
                            calulationPromise={async (value) => {
                              const invoiceAccountBU =
                                await CacheService.getData({
                                  assetType: AssetTypes.Invoicing.AccountBU,
                                  query: MQ.and(
                                    MQ.eq("data.accountNumber", value),
                                    MQ.eq("data.entity", props.entity)
                                  ),
                                  oType: "asset",
                                  forceReload: true,
                                });
                              if (invoiceAccountBU) {
                                return {
                                  value: invoiceAccountBU._id,
                                  data: invoiceAccountBU,
                                };
                              } else {
                                throw new Error(
                                  i18n.t(
                                    "ra:RABookInvoiceForm.BUError",
                                    "Buchungsschlüssel nicht gefunden"
                                  )
                                );
                              }
                            }}
                            renderLoading={() => <Loader size="xs" />}
                            renderError={(error, value: string, reload) => (
                              <div className={`__error`}>
                                {error?.message || "error"}

                                <BFButton
                                  disabled={disableEditAccounting}
                                  tooltip={
                                    disableEditAccounting
                                      ? {
                                          tooltip: i18n.t(
                                            "ra:RABookInvoiceForm.disabledNoPermissionBU",
                                            "Sie haben keine Berechtigung, um Buchungsschlüssel zu erstellen"
                                          ),
                                        }
                                      : undefined
                                  }
                                  appearance="link"
                                  noPadding
                                  size="xs"
                                  onClick={() => {
                                    ModalManager.show({
                                      noPadding: true,
                                      size: "sm",
                                      content: (state, setState, close) => (
                                        <RACAccountBUForm
                                          direction={
                                            props.invoice.data.direction
                                          }
                                          entityId={props.entity}
                                          onClose={close}
                                          onSubmit={(
                                            node: InvoiceAccountBU
                                          ) => {
                                            props.formProps.change(
                                              `data[${props.index}].outstanding.BUCode`,
                                              node.data.accountNumber
                                            );
                                            props.formProps.change(
                                              `data[${props.index}].outstanding.BU`,
                                              node._id
                                            );
                                            close();
                                            reload();
                                          }}
                                          initialValues={{
                                            accountNumber: value,
                                          }}
                                        />
                                      ),
                                    });
                                  }}
                                >
                                  {i18n.t(
                                    "Global.Buttons.establish",
                                    "Anlegen"
                                  )}
                                </BFButton>
                              </div>
                            )}
                            renderValue={(value, data, reload) => (
                              <div className={`__flex full-width`}>
                                <div className={`__flex-1`}>
                                  {data.data.description}
                                </div>

                                <BFButton
                                  disabled={disableEditAccounting}
                                  tooltip={
                                    disableEditAccounting
                                      ? {
                                          tooltip: i18n.t(
                                            "ra:RABookInvoiceForm.disabledNoPermissionBU",
                                            "Sie haben keine Berechtigung, um Buchungsschlüssel zu erstellen"
                                          ),
                                        }
                                      : undefined
                                  }
                                  appearance="link"
                                  noPadding
                                  className={`padding-5`}
                                  size="xs"
                                  onClick={() => {
                                    ModalManager.show({
                                      noPadding: true,
                                      size: "sm",
                                      content: (state, setState, close) => (
                                        <RACAccountBUForm
                                          accountBU={data}
                                          direction={
                                            props.invoice.data.direction
                                          }
                                          entityId={props.entity}
                                          onClose={close}
                                          onSubmit={(
                                            node: InvoiceAccountBU
                                          ) => {
                                            close();
                                            reload();
                                          }}
                                        />
                                      ),
                                    });
                                  }}
                                >
                                  <BfIcon {...DefaultIcons.EDIT} size={"xxs"} />
                                </BFButton>
                              </div>
                            )}
                          />
                        </div>
                      </div>

                      <Field
                        name={`data[${props.index}].outstanding.referenceField`}
                        validate={FV.compose(FV.required())}
                      >
                        {({ input, meta }) => (
                          <>
                            <BFInput
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.referenceField",
                                "Belegfeld 1"
                              )}
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>
                    </div>
                    <div className={`__flex-1`}>
                      <Field
                        name={`data[${props.index}].outstanding.date`}
                        validate={FV.compose(
                          FV.required(),
                          when(
                            InvoiceStruct.getInvoiceBookingEndDate(
                              props.entity
                            ),
                            (date) =>
                              FV.dateAfter(
                                date,
                                i18n.t(
                                  "ra:RABookInvoiceForm.dateBookingEnd",
                                  "Der Buchungszeitraum des abgeschlossenen Geschäftsjahres ist bereits beendet. Neue Buchungen können ab dem {{dateFrom}} vorgenommen werden.",
                                  { dateFrom: StringUtils.formatDate(date) }
                                )
                              )
                          )
                        )}
                      >
                        {({ input, meta }) => (
                          <>
                            <BFDatefield
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.date",
                                "Datum"
                              )}
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>
                      <Field
                        name={`data[${props.index}].outstanding.serviceDate`}
                      >
                        {({ input, meta }) => (
                          <>
                            <BFDatefield
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.serviceDate",
                                "Leistungsdatum"
                              )}
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>
                      <Field name={`data[${props.index}].outstanding.cost1`}>
                        {({ input, meta }) => (
                          <>
                            <BFInput
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.cost1",
                                "KOST 1"
                              )}
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>
                      <Field name={`data[${props.index}].outstanding.cost2`}>
                        {({ input, meta }) => (
                          <>
                            <BFInput
                              noBorderRadiusBottom
                              noBorderRadiusTop
                              prefix={i18n.t(
                                "ra:RABookInvoiceForm.cost2",
                                "KOST 2"
                              )}
                              {...input}
                              {...FV.getValidation(meta)}
                            />
                          </>
                        )}
                      </Field>

                      <FormFieldValues
                        names={[`data[${props.index}].outstanding.extraInfo`]}
                      >
                        {([extraInfo]) => (
                          <Field
                            name={`data[${props.index}].outstanding.usage`}
                            validate={FV.compose(FV.required())}
                          >
                            {({ input, meta }) => (
                              <>
                                <BFInput
                                  noBorderRadiusBottom={extraInfo?.length > 0}
                                  noBorderRadiusTop
                                  prefix={i18n.t(
                                    "ra:RABookInvoiceForm.usage",
                                    "Buchungstext"
                                  )}
                                  {...input}
                                  {...FV.getValidation(meta)}
                                />
                              </>
                            )}
                          </Field>
                        )}
                      </FormFieldValues>
                      <FieldArray<string>
                        name={`data[${props.index}].outstanding.extraInfo`}
                      >
                        {({ fields }) => (
                          <>
                            {fields?.map((name, index) => (
                              <Field
                                name={name}
                                key={index}
                                validate={FV.required()}
                              >
                                {({ input, meta }) => (
                                  <>
                                    <BFInput
                                      noBorderRadiusBottom={
                                        index < fields.length - 1
                                      }
                                      noBorderRadiusTop
                                      prefix={
                                        i18n.t(
                                          "ra:RABookInvoiceForm.extraInfo",
                                          "Zusatzinfo"
                                        ) +
                                        " " +
                                        (index + 1)
                                      }
                                      {...input}
                                      {...FV.getValidation(meta)}
                                      removeSuffixPadding
                                      suffix={
                                        <div>
                                          <BFButton
                                            appearance="link"
                                            size="sm"
                                            onClick={() => fields.remove(index)}
                                          >
                                            <BfIcon
                                              {...DefaultIcons.CLOSE}
                                              size="xxs"
                                            />
                                          </BFButton>
                                        </div>
                                      }
                                    />
                                  </>
                                )}
                              </Field>
                            ))}
                            <div className={`__flex __justify-center`}>
                              <BFButton
                                appearance="link"
                                size="xs"
                                onClick={() => fields.push("")}
                              >
                                {i18n.t(
                                  "ra:RABookInvoiceForm.addExtraInfo",
                                  "Zusatzinfo anlegen"
                                )}
                              </BFButton>
                            </div>
                          </>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </div>
              </Collapse>
            )}
          </FormFieldValues>
        </div>
      )}
    </FormFieldValues>
  );
};

const PaymentOverlay = (props: {
  index: number;
  invoice: Invoice;
  value: number;
  onChange: (value: number) => void;
}) => {
  const calculateNewValue = (ids: string[]) => {
    const payments = [
      ...(props.invoice.data.payment || []),
      ...(props.invoice.data.installment || []),
    ];
    const newValue = payments
      .filter((payment) => ids.includes(payment.id))
      .reduce((sum, payment) => sum + payment.amount, 0);
    props.onChange(newValue);
  };

  return (
    <>
      <div className={`padding-10`}>
        <div
          className={`__sub-text padding-bottom-10`}
          style={{
            maxWidth: 300,
          }}
        >
          {i18n.t(
            "cb:CBIdlyConnect.DecsriptionCheckPayments",
            "Bitte wählen Sie hier die Zahlungspositionen aus, die als verbucht markiert werden sollen. Die Beträge werden automatisch auf die Buchungssumme übertragen. Sie können den Betrag jedoch manuell anpassen"
          )}
        </div>
        <FormFieldValues
          names={[
            `data[${props.index}].finishedPayments`,
            `data[${props.index}].finishedInstallments`,
          ]}
        >
          {([finishedPayments, finishedInstallments]) => (
            <>
              <Field name={`data[${props.index}].finishedPayments`}>
                {({ input, meta }) => {
                  const ids = input.value || [];
                  return (
                    <>
                      {Boolean(props.invoice.data.payment?.length) && (
                        <div>
                          <div className={`__h3 `}>
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.payments",
                              "Zahlungen"
                            )}
                          </div>
                          {props.invoice.data.payment.map((payment) => {
                            const hasPayedDate = Boolean(payment.payedDate);
                            const isSelected = hasPayedDate
                              ? true
                              : ids.includes(payment.id);

                            return (
                              <div>
                                <BFCheckbox
                                  checked={isSelected}
                                  onChange={(_, checked) => {
                                    let newValue = checked
                                      ? [...ids, payment.id]
                                      : ids.filter((id) => id !== payment.id);
                                    calculateNewValue([
                                      ...newValue,
                                      ...(finishedInstallments || []),
                                    ]);
                                    input.onChange(newValue);
                                  }}
                                  disabled={hasPayedDate}
                                >
                                  <>
                                    <span className={`padding-right-10 bold`}>
                                      {StringUtils.formatCurrency(
                                        payment.amount
                                      )}
                                    </span>
                                    <span className={`__sub-text`}>
                                      {StringUtils.formatDate(payment.date)}
                                    </span>
                                    <span className={`padding-left-10`}>
                                      {payment.usage}
                                    </span>
                                  </>
                                </BFCheckbox>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                }}
              </Field>

              <Field name={`data[${props.index}].finishedInstallments`}>
                {({ input, meta }) => {
                  const ids = input.value || [];
                  return (
                    <>
                      {Boolean(props.invoice.data.installment?.length) && (
                        <div className={`padding-top-10`}>
                          <div className={`__h3`}>
                            {i18n.t(
                              "cb:CBIdlyConnect.Invoice.installments",
                              "Abschläge"
                            )}
                          </div>
                          {props.invoice.data.installment.map((payment) => {
                            const hasPayedDate = Boolean(payment.payedDate);
                            const isSelected = hasPayedDate
                              ? true
                              : ids.includes(payment.id);

                            return (
                              <div>
                                <BFCheckbox
                                  checked={isSelected}
                                  onChange={(_, checked) => {
                                    let newValue = checked
                                      ? [...ids, payment.id]
                                      : ids.filter((id) => id !== payment.id);
                                    calculateNewValue([
                                      ...newValue,
                                      ...(finishedPayments || []),
                                    ]);
                                    input.onChange(newValue);
                                  }}
                                  disabled={hasPayedDate}
                                >
                                  <>
                                    <span className={`padding-right-10 bold`}>
                                      {StringUtils.formatCurrency(
                                        payment.amount
                                      )}
                                    </span>
                                    <span className={`__sub-text`}>
                                      {StringUtils.formatDate(payment.date)}
                                    </span>
                                    <span className={`padding-left-10`}>
                                      {payment.usage}
                                    </span>
                                  </>
                                </BFCheckbox>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                }}
              </Field>
            </>
          )}
        </FormFieldValues>
      </div>
    </>
  );
};
